import { Action } from 'redux';
import { Data } from './types';

export const UPDATE_FAVORITE_REQUEST = 'UPDATE_FAVORITE_REQUEST';
export const UPDATE_FAVORITE_SUCCESS = 'UPDATE_FAVORITE_SUCCESS';
export const UPDATE_FAVORITE_ERROR = 'UPDATE_FAVORITE_ERROR';

export const FETCH_LIST_FAVORITE_REQUEST = 'FETCH_LIST_FAVORITE_REQUEST';
export const FETCH_LIST_FAVORITE_SUCCESS = 'FETCH_LIST_FAVORITE_SUCCESS';
export const FETCH_LIST_FAVORITE_ERROR = 'FETCH_LIST_FAVORITE_ERROR';

export const UPDATE_FAVORITE_LIST = 'UPDATE_FAVORITE_LIST';
export const FAVORITE_LIST_LOCAL = 'FAVORITE_LIST_LOCAL';

export interface FetchDataAction extends Action<typeof UPDATE_FAVORITE_REQUEST> {
    payload: any;
}
export interface FetchDataSuccessAction extends Action<typeof UPDATE_FAVORITE_SUCCESS> {
    payload: Data[];
}

export interface FetchDataErrorAction extends Action<typeof UPDATE_FAVORITE_ERROR> {
    payload: Error;
}

export interface FetchListDataAction extends Action<typeof FETCH_LIST_FAVORITE_REQUEST> {
    payload: any;
}
export interface FetchListDataSuccessAction extends Action<typeof FETCH_LIST_FAVORITE_SUCCESS> {
    payload: Data[];
}

export interface FetchListDataErrorAction extends Action<typeof FETCH_LIST_FAVORITE_ERROR> {
    payload: Error;
}

export const updateFavoriteRequest = (data: any): FetchDataAction => ({
    type: UPDATE_FAVORITE_REQUEST,
    payload: data,
});

export const updateFavoriteSuccess = (data: any): FetchDataSuccessAction => ({
    type: UPDATE_FAVORITE_SUCCESS,
    payload: data,
});

export const updateFavoriteError = (error: any): FetchDataErrorAction => ({
    type: UPDATE_FAVORITE_ERROR,
    payload: error,
});

export const fetchListFavoriteRequest = (data: any): FetchListDataAction => ({
    type: FETCH_LIST_FAVORITE_REQUEST,
    payload: data,
});

export const fetchListFavoriteSuccess = (data: any): FetchListDataSuccessAction => ({
    type: FETCH_LIST_FAVORITE_SUCCESS,
    payload: data,
});

export const fetchListFavoriteError = (error: any): FetchListDataErrorAction => ({
    type: FETCH_LIST_FAVORITE_ERROR,
    payload: error,
});

export const updateFavoriteList = (
    data: any
): { payload: any; type: string } => ({
    type: UPDATE_FAVORITE_LIST,
    payload: data,
});

export const updateFavoriteListLocal = (
    data: any
): { payload: any; type: string } => ({
    type: FAVORITE_LIST_LOCAL,
    payload: data,
});